import React, { useState, forwardRef, useImperativeHandle } from 'react';

const LayoutPanel = forwardRef(({ eventId }, ref) => {
  const [layout, setLayout] = useState({
    month: true,
    weekly: true,
    column: true,
  });

  useImperativeHandle(ref, () => ({
    getState: () => layout,
  }));

  const toggle = (key) => {
    setLayout((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div>
      {['month', 'weekly', 'column'].map((key) => (
        <div key={key} className="form-check mb-2">
          <input
            className="form-check-input"
            type="checkbox"
            id={`layout-${key}`}
            checked={layout[key]}
            onChange={() => toggle(key)}
          />
          <label className="form-check-label" htmlFor={`layout-${key}`}>
            {key.charAt(0).toUpperCase() + key.slice(1)}
          </label>
        </div>
      ))}
    </div>
  );
});

export default LayoutPanel;
